import { SITUACAO_VOTO } from '@/dominio/SituacaoVoto';
import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroVotacaoComVotoDiferenteDeConfirmadoPorMagistrado extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Votação incompleta (com voto em situação diferente de "Confirmado") por magistrado';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    #siglasMagistradosComVotoDiferentesDeConfirmado = (registro) => {
        const composicaoComVotos = this.store.rootStore.sessaoStore.montarComposicaoComVotos(registro);
        const votosDiferentesDeConfirmado = composicaoComVotos.filter((mag) => {
            return !mag.relator && mag.voto?.situacaoVoto !== SITUACAO_VOTO.CONFIRMADO.id;
        });

        return votosDiferentesDeConfirmado.map((mag) => mag.siglaDoMagistrado);
    };

    getValorOpcao(registro) {
        return this.#siglasMagistradosComVotoDiferentesDeConfirmado(registro);
    }
}
